import { inject, observer } from "mobx-react";
import { autorun, reaction } from "mobx";
import React from "react";
import { WithTranslation, withTranslation } from "react-i18next";
import { Redirect } from "react-router-dom";
import { Button, Container, Icon, Responsive } from "semantic-ui-react";
import { IAppModel } from "../../AppModel";
import { Loading } from "../../components/common/loading";
import { IAuthModel } from "../../modules/auth/AuthModel";
import {IAgreementListModel } from "../../modules/loan/agreement/AgreementListModel"; 
import {IRequestListModel } from "../../modules/loan/request/RequestListModel"; 
import {IGuaranteeListModel } from "../../modules/loan/guarantee/GuaranteeListModel"; 
import {IAccountReceivableListModel } from "../../modules/accountReceivable/AccountReceivableListModel"; 
import MobilePageLayout from "./MobilePageLayout";
import FallBack from "../../pages/layouts/partials/FallBack";
import MainSidebarMenus from "../../pages/layouts/partials/MainSidebarMenus";

interface IMobileLayout extends WithTranslation { 
  location?: any;
  children: any;
  authStore?: IAuthModel;
  appStore?: IAppModel;
  searchRequestListStore?: IRequestListModel;
  searchGuaranteeListStore?: IGuaranteeListModel;
  searchAccountReceivableListStore?: IAccountReceivableListModel;
  searchAgreementListStore?: IAgreementListModel;

}
@inject("authStore", "appStore","searchGuaranteeListStore","searchRequestListStore","searchAccountReceivableListStore","searchAgreementListStore")
@observer
class MobileLayout extends React.Component<IMobileLayout, any> {
  public PADDING_HEADER_AND_CONTENT_MOBILE = 0;
  public PADDING_HEADER_AND_CONTENT_COMP = 0;
  
  constructor(props: any) {
    super(props);
    if (this.props.authStore!.userProfile.id === "") {
      this.props.authStore!.getUserProfile();      
    }    
    const {id, firstname, lastname, username} = this.props.authStore!.userProfile;  

  }
  public state = {
    expanded: true,
    mobile: false
  };

  public async componentDidUpdate(prevProps: any, prevState: any) {
    if (this.props.location !== prevProps.location) {
      window.scrollTo(0, 0);
    }
  }

  public async componentDidMount() {
    try {
      await this.props.appStore!.setScreenHeight();
      await this.props.appStore!.setScreenMode();
      await this.props.appStore!.getEnumset();
      await this.handleOnUpdate();      
    } catch (e) {
      console.log(e);
      throw e;
    }   
    
    // auto load data on start
    autorun(() => {
      if (this.props.authStore!.userProfile.username !== "") {        
        this.props.searchRequestListStore!.setField({
          fieldname: "idcardRequestOnline",
          value: this.props.authStore!.userProfile.username ? this.props.authStore!.userProfile.username : 'null'
        });
        this.props.searchRequestListStore!.load_data();

        // SEARCH Guarantee List
        //if(this.props.searchGuaranteeListStore!.total === undefined) {
          this.props.searchGuaranteeListStore?.setField({ 
              fieldname: "filterIdCardNo", 
              value: this.props.authStore!.userProfile.username ? this.props.authStore!.userProfile.username : 'null'
          });
          this.props.searchGuaranteeListStore?.load_data();
        //}

        // agreement use for guarantor detail page
          this.props.searchAgreementListStore!.setField({
            fieldname: "filterGuarantorIdCardNo",           
            value: this.props.authStore!.userProfile.username ? this.props.authStore!.userProfile.username : 'null'
          });
          this.props.searchAgreementListStore!.load_data();              


        //if(this.props.searchAccountReceivableListStore!.total === undefined) {      
          this.props.searchAccountReceivableListStore!.setField({
            fieldname: "filterIdCardNo",
            value: this.props.authStore!.userProfile.username ? this.props.authStore!.userProfile.username : 'null'
          });
          this.props.searchAccountReceivableListStore!.load_data();    



      }});

  }

  public render() {
    const { expanded, mobile } = this.state;
    const { t } = this.props;
    return this.props.authStore!.access_token !== "" ||
      window.localStorage.getItem("access_token") ? (
      <div style={styles.pageWrapper}>
        <Responsive onUpdate={this.handleOnUpdate} />
        <div>
          <MobilePageLayout paddingLeft={expanded ? "18em" : "5em"}>
            <Loading active={this.props.appStore!.loading} />
            <FallBack inverted>{this.props.children}</FallBack>
          </MobilePageLayout>
        </div>
      </div>
    ) : (
      <Redirect to="/mobile/login" />
    );
  }
  private checkActive = (groupName: string) => {
    // เช็คว่า path slash แรก มีค่าตรงกับ groupName ไหม เช่น /admin/role_permission จะเช็ค admin กับ groupName
    return this.props.appStore!.pageHeader === groupName;
  };

  private onToggle = async (expanded: boolean) => {
    await this.setState({ expanded });
  };

  private handleOnUpdate = async () => {
    await this.setState({
      expanded: window.innerWidth >= 767,
      mobile: window.innerWidth < 767
    });
    await this.props.appStore!.setHeaderHeight();
    await this.props.appStore!.setScreenHeight();
    await this.props.appStore!.setScreenMode();
  };
}
const styles: any = {
  pageWrapper: { width: "100%", height: "100%", margin: 0, padding: 0 },
  left: {
    position: "fixed",
    top: 0,
    height: "100vh",
    backgroundColor: "#1b1c1d",
    overflowY: "scroll"
  },
  right: {
    // marginTop: 120,
    // paddingLeft: "18em",
    background: "#F2F3F5",
    overflowY: "scroll",
    overflowX: "hidden"
  },
  top: {
    position: "fixed",
    top: 0,
    left: 250,
    right: 0,
    height: 54,
    zIndex: 1000,
    background: "#ff0",
    border: "2px solid red"
  },
  sidebarColumn: { padding: 0, background: "#1A1B1C" },
  contentColumn: {
    background: "#F2F3F5",
    margin: 0,
    padding: 0,
    height: "100vh",
    overflowY: "auto",
    overflowX: "hidden"
  },
  signoutButton: {
    padding: "10px",
    textAlign: "center"
  },
  signoutIcon: { cursor: "pointer" },
  pageHeaderElementStyle: {
    marginTop: -20
  },
  version: {
    textAlign: "center",
    color: "gray",
    position: "fixed",
    bottom: 0,
    left: 0,
    background: "#1A1B1C",
    padding: " 10px 0px"
  }
};

export default withTranslation()(MobileLayout);
